import { useState, useEffect } from 'react';
import { formatCountdown } from '../utils/formatters';

// Accepts either a Unix timestamp (number) or an ISO date string from the API
function toMs(value) {
  if (!value) return 0;
  if (typeof value === 'number') return value;
  return new Date(value).getTime();
}

export function useCountdown(targetValue) {
  const targetMs = toMs(targetValue);
  const [remaining, setRemaining] = useState(Math.max(0, targetMs - Date.now()));
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const ms = toMs(targetValue);
    setRemaining(Math.max(0, ms - Date.now()));
    setTriggered(false);

    const id = setInterval(() => {
      const r = Math.max(0, ms - Date.now());
      setRemaining(r);
      if (r === 0) {
        setTriggered(true);
        clearInterval(id);
      }
    }, 1000);

    return () => clearInterval(id);
  }, [targetValue]);

  return { remaining, formatted: formatCountdown(remaining), triggered };
}
